// import produce from 'immer'
// import React, { useEffect, useState } from 'react'
// import { useSelector, useDispatch } from 'react-redux'
// import { useRouteMatch, useHistory } from 'react-router'
// import FileAllocationFilters from '../../../../components/filters/FileAllocationFilters'
// import IterminalTableComponent from '../../../../components/table/IterminalTableComponent'
// import { FilterModel } from '../../../../models/utils/filterModel'
// import { FilterOptionModel } from '../../../../models/utils/filterOption'
// import seService from '../../../../services/applicationRegistration/loan/seService'
// import { filtersSetRequest } from '../../../../store/filter/actions'
// import { getFilters } from '../../../../store/filter/selectors'
// import {
//   defaultOrderListLimit,
//   defaultPageLimit,
// } from '../../../../utils/constants'
// import {
//   fileAllocationFilters,
//   fileRegistrationLoanColumns,
// } from '../../../../utils/metaData'
// import { getPageCount } from '../../../../utils/tableFunctions'

// const SeAttribute = () => {
//   const filterOption = {
//     descending: true,
//     limit: defaultPageLimit,
//     orderFields: defaultOrderListLimit,
//   } as FilterModel
//   const [filter, setFilter] = useState(filterOption)
//   const [pageCount, setPageCount] = useState(0)
//   const [dataCount, setDatacount] = useState(0)
//   const [state, setstate] = useState([])
//   const [loading, setLoading] = useState(true)
//   const filters = useSelector(getFilters)
//   const { path } = useRouteMatch()
//   const history = useHistory()
//   const dispatch = useDispatch()

//   useEffect(() => {
//     dispatch(filtersSetRequest({ filters: fileAllocationFilters }))
//     async function getApplicationFiles() {
//       await retriveDataCountAndData(filter)
//       setLoading(false)
//     }
//     getApplicationFiles()
//   }, [])

//   const columns = React.useMemo(() => fileRegistrationLoanColumns, [])

//   const retriveApplicationFilesData = async (pageDetails: any) => {
//     setLoading(true)
//     const newFilter = produce(filter, (draft) => {
//       draft.page = pageDetails.pageIndex + 1
//     })
//     setFilter(newFilter)
//     const applicationData = await seService.apiFetchSeAttributeList(newFilter)
//     setstate(applicationData.data)
//     setLoading(false)
//   }

//   const retriveFilterData = async (selectedFilters: FilterOptionModel[]) => {
//     console.log(selectedFilters)
//     setLoading(true)
//     const newFilter = produce(filter, (draft) => {
//       draft.page = 1
//       draft.filterData = selectedFilters
//     })
//     setFilter(newFilter)
//     await retriveDataCountAndData(newFilter)
//     setLoading(false)
//   }

//   async function retriveDataCountAndData(filterData: FilterModel) {
//     const applicationCountData = await seService.apiFetchSeAttributeListCount(
//       filterData
//     )
//     if (applicationCountData.status === 200) {
//       setDatacount(applicationCountData.data.count)
//       setPageCount(
//         getPageCount(applicationCountData.data.count, filterOption.limit)
//       )
//       const applicationData = await seService.apiFetchSeAttributeList(
//         filterData
//       )
//       setstate(applicationData.data)
//     } else {
//       setDatacount(0)
//       setPageCount(0)
//       setstate([])
//     }
//   }

//   const handleView = (id: number) => {
//     history.push(`${path}attribute/${id}`)
//   }
//   return (
//     <>
//       {!loading && (
//         <div className="mb-4">
//           <FileAllocationFilters
//             filterData={filters}
//             onFilter={(e: FilterOptionModel[]) => {
//               dispatch(filtersSetRequest({ filters: e }))
//               retriveFilterData(
//                 e.filter(
//                   (filter: FilterOptionModel) => filter.selected === true
//                 )
//               )
//             }}
//           />
//         </div>
//       )}
//       <div>
//         <IterminalTableComponent
//           columns={columns}
//           data={state}
//           fetchData={retriveApplicationFilesData}
//           loading={loading}
//           pageCount={pageCount}
//           totalCount={dataCount}
//           onClickRow={(row: any) => {
//             handleView(row.id)
//           }}
//         />
//       </div>
//     </>
//   )
// }

// export default SeAttribute

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useRouteMatch, useHistory } from 'react-router-dom'
import { defaultPageLimit } from '../../../../utils/constants'
import AdvancedSearchTable from '../../../../components/table/advancedSearchTable/AdvancedSearchTable'
import { fileRegistrationLoanColumns } from '../../../../components/table/advancedSearchTable/AdvancedSearchTableUtil'
import { AdvancedFilterModel } from '../../../../models/utils/filterModel'
import { filtersSetRequest } from '../../../../store/filter/actions'
import { fileAllocationFilters } from '../../../../utils/metaData'

const SeAttribute = () => {
  // Initialize the filter option as per the AdvancedSearchTable requirements
  const initFilterOption = {
    filterValue: null,
    limit: defaultPageLimit, // Adjust if needed
    page: 1,
    orderBy: 'created_date_time', // Adjust the default orderBy field if necessary
    order: 'DESC',
  } as AdvancedFilterModel

  const { path } = useRouteMatch()
  const history = useHistory()
  const dispatch = useDispatch()

  // Effect to set the filters in the Redux store
  useEffect(() => {
    dispatch(filtersSetRequest({ filters: fileAllocationFilters }))
  }, [dispatch])

  // Handle row click event
  const handleView = (id: number) => {
    history.push(`${path}attribute/${id}`)
  }

  return (
    <>
      <AdvancedSearchTable
        withIndentType={false}
        initFilterOption={initFilterOption} // Pass the initialized filter option
        columns={fileRegistrationLoanColumns} // Use the columns relevant to your data
        dataApiPath={'/application-registration/loan/se/attribute/view/list'} // Set to your actual data API path
        countApiPath={'/application-registration/loan/se/attribute/view/count'} // Set to your actual count API path
        onClickRow={(row: any) => {
          handleView(row.id) // Handle row clicks
        }}
      />
    </>
  )
}

export default SeAttribute
